import { useQuery } from 'react-query';
import { captureException } from '@sentry/nextjs';
import { OrganizationsService } from '~/src/services/organizations.service';
import type {
    AddressSuggestionProps,
} from '~/src/components/common-components/dropdown-address-item/dropdown-address-item.types';
import type { Dispatch, SetStateAction } from 'react';

const QUERY_KEY = 'address organizations';

export const useFetchAddressOrganizations = (
    searchString: string,
    setAddressDataState: Dispatch<SetStateAction<AddressSuggestionProps[] | []>>,
) => {
    const { refetch } = useQuery([QUERY_KEY, searchString],
        () => OrganizationsService.getOrganizationAddress(searchString), {
            onSuccess: (addressArray) => {
                setAddressDataState(addressArray || []);
            },
            onError: (error) => {
                captureException(error);
                // eslint-disable-next-line no-console
                console.log(QUERY_KEY, error);
            },
            enabled: false,
        });

    return { refetch };
};